import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  WaypointStatus,
  WaypointStatusLabel,
} from '../../../generated_client/model/enumWaypointStatus';

@Component({
  selector: 'app-waypoint-status-modal',
  template: `
    <div class="modal-content">
      <div class="modal-header">
        <h2>Cambiar Estado de Parada</h2>
        <ion-button 
          fill="clear" 
          class="close-button" 
          (click)="closeModal()">
          <ion-icon name="close" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
      
      <div class="modal-body">
        <div class="waypoint-info">
          <div class="info-label">Dirección:</div>
          <div class="info-value">{{ waypoint?.address || waypoint?.description || '-' }}</div>
        </div>
        
        <div class="status-section">
          <div class="section-title">Seleccionar nuevo estado:</div>
          <div class="status-options">
            <ion-button
              *ngFor="let status of availableStatuses"
              fill="outline"
              expand="block"
              class="status-button"
              [disabled]="status.disabled"
              (click)="selectStatus(status.value)">
              {{ status.label }}
            </ion-button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 90%;
      max-width: 420px;
      margin: 0 auto;
      background: transparent !important;
    }

    .modal-content {
      background: white;
      border-radius: 16px;
      overflow: hidden;
      max-height: 80vh;
      display: flex;
      flex-direction: column;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1);
      margin: 20px;
    }

    @media (max-width: 480px) {
      .modal-content {
        max-height: 90vh;
        margin: 10px;
      }
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 60px 20px 24px; /* Más padding a la derecha para el botón */
      background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
      color: white;
      position: relative;
      min-height: 60px;
    }

    .modal-header h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      color: white;
      flex: 1;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      padding-right: 16px; /* Espacio para el botón */
      line-height: 1.3;
      word-wrap: break-word;
    }

    .close-button {
      --color: white;
      --background: #1d4ed8;
      --border-color: transparent;
      --box-shadow: none;
      --padding-start: 0;
      --padding-end: 0;
      --border-radius: 50%;
      margin: 0;
      height: 32px;
      width: 32px;
      position: absolute;
      top: 14px;
      right: 16px;
      z-index: 10;
      flex-shrink: 0;
      border: none;
      box-shadow: none !important;
    }

    .close-button ion-icon {
      font-size: 18px;
      color: white;
    }

    .close-button:hover {
      --background: #1e40af;
      --color: white;
    }

    /* Responsive para pantallas pequeñas */
    @media (max-width: 480px) {
      .modal-header {
        padding: 16px 50px 16px 16px;
        min-height: 56px;
      }
      
      .modal-header h2 {
        font-size: 16px;
        padding-right: 12px;
      }
      
      .close-button {
        height: 28px;
        width: 28px;
        top: 14px;
        right: 12px;
      }
      
      .close-button ion-icon {
        font-size: 16px;
      }
    }

    .modal-body {
      padding: 24px;
      flex: 1;
      overflow-y: auto;
      background: white;
      min-height: 0;
      -webkit-overflow-scrolling: touch;
    }

    @media (max-width: 480px) {
      .modal-body {
        padding: 16px;
      }
    }

    .waypoint-info {
      margin-bottom: 24px;
      padding: 16px;
      background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
      border-left: 4px solid #3b82f6;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
    }

    @media (max-width: 480px) {
      .waypoint-info {
        margin-bottom: 20px;
        padding: 14px;
      }
    }

    .info-label {
      font-size: 15px;
      font-weight: 700;
      color: #1e40af;
      margin-bottom: 6px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .info-value {
      font-size: 16px;
      color: #374151;
      line-height: 1.5;
      font-weight: 500;
    }

    .status-section {
      margin-bottom: 20px;
    }

    .section-title {
      font-size: 17px;
      font-weight: 700;
      color: #1f2937;
      margin-bottom: 16px;
      text-align: center;
    }

    @media (max-width: 480px) {
      .section-title {
        font-size: 16px;
        margin-bottom: 14px;
      }
    }

    .status-options {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding-bottom: 8px;
    }

    @media (max-width: 480px) {
      .status-options {
        gap: 8px;
      }
    }

    .status-button {
      --border-color: #E0E0E0;
      --color: #374151;
      --background: white;
      --border-radius: 12px;
      --box-shadow: none;
      --border-width: 1px;
      --border-style: solid;
      --padding-start: 16px;
      --padding-end: 16px;
      margin: 0;
      height: 48px;
      font-size: 15px;
      font-weight: 500;
      text-transform: none;
      border: 1px solid #E0E0E0 !important;
      box-shadow: none !important;
      background: white !important;
      transition: all 0.2s ease;
      position: relative;
      overflow: hidden;
    }

    @media (max-width: 480px) {
      .status-button {
        height: 44px;
        font-size: 14px;
        --padding-start: 12px;
        --padding-end: 12px;
      }
    }

    /* Eliminar pseudo-elementos que puedan crear doble borde */
    .status-button::before,
    .status-button::after {
      display: none !important;
    }

    /* Eliminar cualquier sombra o borde adicional de ion-button */
    .status-button .button-native {
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
    }

    .status-button:hover {
      --background: #f8fafc;
      --border-color: #3b82f6;
      --color: #3b82f6;
      border-color: #3b82f6 !important;
      background: #f8fafc !important;
      transform: none;
      box-shadow: none !important;
    }

    .status-button:active {
      transform: none;
      box-shadow: none !important;
      background: #f1f5f9 !important;
    }

    /* Asegurar que no haya estilos adicionales de Ionic */
    .status-button.ion-activated {
      --background: #f1f5f9;
      background: #f1f5f9 !important;
      box-shadow: none !important;
    }

    .status-button:disabled,
    .status-button[disabled] {
      --background: #f5f5f5;
      --color: #9e9e9e;
      --border-color: #e0e0e0;
      background: #f5f5f5 !important;
      color: #9e9e9e !important;
      border-color: #e0e0e0 !important;
      opacity: 0.6;
      cursor: not-allowed;
    }

    .status-button:disabled:hover,
    .status-button[disabled]:hover {
      --background: #f5f5f5;
      --color: #9e9e9e;
      --border-color: #e0e0e0;
      background: #f5f5f5 !important;
      transform: none;
    }
  `]
})
export class WaypointStatusModalComponent {
  @Input() waypoint: any = null;
  @Input() availableStatuses: { label: string; value: number; disabled?: boolean }[] = [];

  constructor(private modalController: ModalController) {}

  closeModal() {
    this.modalController.dismiss();
  }

  selectStatus(status: number) {
    this.modalController.dismiss({
      selectedStatus: status,
      waypointId: this.waypoint?.id
    });
  }
}
